<template>
  <div class="login-container">
    <h2 class="login-title">管理员登录</h2>
    <form @submit.prevent="handleLogin" class="login-form">
      <div class="form-group">
        <label for="username" class="form-label">用户名:</label>
        <input
          type="text"
          id="username"
          v-model="username"
          class="form-input"
          required
          placeholder="请输入用户名"
        />
      </div>
      <div class="form-group">
        <label for="password" class="form-label">密码:</label>
        <input
          type="password"
          id="password"
          v-model="password"
          class="form-input"
          required
          placeholder="请输入密码"
        />
      </div>
      <button type="submit" class="login-button" @click="login">登录</button>
    </form>
    <div class="social-login">
      <button type="button" class="social-login-button">
        微信登录
      </button>
      <button type="button" class="social-login-button" @click="handleRegister">注册</button>
    </div>
    <p v-if="errorMessage" class="error-message">{{ errorMessage }}</p>
  </div>
</template>

<style>
:root {
  --primary-color: #6366f1;
  --primary-hover: #4f46e5;
  --error-color: #ef4444;
  --text-color: #374151;
  --bg-color: #f9fafb;
  --border-color: #e5e7eb;
  --input-bg: #ffffff;
  --input-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  --social-button-size: 0.875rem;
}

.login-container {
  max-width: 400px;
  margin: 2rem auto;
  padding: 2rem;
  background: rgba(255, 255, 255, 0.9);
  border-radius: 0.5rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.login-container::before {
  content: '';
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: url('@/assets/image/background.jpg');
  background-size: cover;
  background-position: center;
  z-index: -1;
}

.login-title {
  font-size: 1.5rem;
  font-weight: 600;
  color: var(--text-color);
  text-align: center;
  margin-bottom: 1.5rem;
}

.login-form {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.form-label {
  font-size: 0.875rem;
  color: var(--text-color);
}

.form-input {
  padding: 0.75rem;
  border: 1px solid var(--border-color);
  border-radius: 0.375rem;
  font-size: 1rem;
  background-color: var(--input-bg);
  box-shadow: var(--input-shadow);
  transition: all 0.2s;
}

.form-input:focus {
  outline: none;
  border-color: var(--primary-color);
  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.2);
}

.form-input:focus {
  outline: none;
  border-color: var(--primary-color);
}

.login-button {
  padding: 0.75rem;
  background-color: var(--primary-color);
  color: white;
  border: none;
  border-radius: 0.375rem;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
}

.login-button:hover {
  background-color: var(--primary-hover);
}

.social-login {
  display: flex;
  flex-direction: row;
  gap: 0.5rem;
  margin-top: 1.5rem;
  padding-top: 1rem;
  border-top: 1px solid var(--border-color);
}

.social-login .login-button {
  flex: 1;
  padding: 0.5rem;
  font-size: var(--social-button-size);
  background-color: transparent;
  color: var(--text-color);
  border: 1px solid var(--border-color);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  transition: all 0.2s ease;
}

.social-login .login-button:hover {
  background-color: var(--bg-color);
  transform: translateY(-2px);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.social-login .login-button {
  position: relative;
  padding-left: 2.5rem;
}

.social-login .login-button img {
  position: absolute;
  left: 0.75rem;
  top: 50%;
  transform: translateY(-50%);
  width: 1.25rem;
  height: 1.25rem;
}

.error-message {
  color: var(--error-color);
  font-size: 0.875rem;
  text-align: center;
  margin-top: 1rem;
}
</style>

<script>
export default {
  data() {
    return {
      username: '',
      password: '',
      error: ''
    };
  },
  methods: {
    login() {
      // 这里假设正确的密码是 "123456"
      if (this.password === '123456') {
        this.$router.push('/dashboard');
      } else {
        this.error = '密码错误，请重试！';
      }
    },
    handleRegister() {
      alert('暂不支持');
    }
  }
};
</script>


